/**
 * True for a parseable absolute http(s) URL — the only kind of image source
 * the Highlights gallery / ad-preview cards should ever hand to an <img>.
 * Guards against corrupted backend payloads (e.g. the comma-split URL
 * fragments like "h_440" produced by the legacy simple-array image storage,
 * AUT-16) rendering as broken question-mark tiles and inflating photo counts.
 */
export function isRenderableImageUrl(
  value: string | undefined | null,
): value is string {
  if (!value) return false;
  try {
    const { protocol } = new URL(value);
    return protocol === "http:" || protocol === "https:";
  } catch {
    return false;
  }
}
